import React from 'react';
import PropTypes from 'prop-types';

export default function RegisterButtons(){
  return (
    // <section id={section_id} className="about-section">
    <div className="about-section">
      <div className="registers-container">        
        <a href="https://spiredatasets.ee.iisc.ac.in/syspincorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SYSPIN Dataset
        </a>

        <a href="https://spiredatasets.ee.iisc.ac.in/englishttscorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SPICOR TTS_1.0 Dataset
        </a>

        <a href="https://spiredatasets.ee.iisc.ac.in/gujaratittscorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SPICOR TTS_2.0 Dataset
        </a>
      </div>
      <div className="registers-container">
        <a href="/register" className="register-btn-outline" target='_blank' rel='noreferrer '>
          Register Now
        </a>
      </div>
    {/* // </section> */}
    </div>
  )
}

RegisterButtons.propTypes = {
  section_id: PropTypes.string.isRequired
}
